export default __webpack_public_path__ + "locales/lv/InviteDialog.json?hash=258bc5309bce085884e6d58cf0fec663";